module.exports = __webpack_public_path__ + "static/media/user (3).40ffbef8.png";